import { apiClient, assertOk } from "@/api/generated/client.ts"

// The backend route takes a provider plus a catch-all path. Dashboard call
// sites keep their compact provider/path notation without losing endpoint
// typing at the transport boundary.
export const getLiveTagValue = async (tagPath: string): Promise<number> => {
  const [provider, ...pathSegments] = tagPath.split("/")
  if (!provider || pathSegments.length === 0) {
    throw new Error(`A live tag path must include a provider and path: ${tagPath}`)
  }

  const { data, error, response } = await apiClient.GET("/api/Tags/live/{provider}/{path}", {
    params: { path: { provider, path: pathSegments.join("/") } },
  })
  return assertOk(response, error, data)
}
